export default "__VITE_PUBLIC_ASSET__9e111a80__"